export interface DollarSymbolConfig {
    left: string
    top: string
    fontSize: string
    opacity: number
    duration: number
    delay: number
}

export const DOLLAR_SYMBOLS: DollarSymbolConfig[] = [
    { left: '8%', top: '6%', fontSize: '2.4rem', opacity: 0.45, duration: 7, delay: 0 },
    { left: '22%', top: '14%', fontSize: '1.6rem', opacity: 0.35, duration: 9, delay: 0.8 },
    { left: '75%', top: '8%', fontSize: '2rem', opacity: 0.5, duration: 8, delay: 0.3 },
    { left: '88%', top: '22%', fontSize: '1.4rem', opacity: 0.4, duration: 10, delay: 1.2 },
    { left: '5%', top: '38%', fontSize: '1.8rem', opacity: 0.35, duration: 11, delay: 0.5 },
    { left: '18%', top: '52%', fontSize: '2.2rem', opacity: 0.45, duration: 7.5, delay: 1.5 },
    { left: '82%', top: '48%', fontSize: '1.7rem', opacity: 0.38, duration: 9.5, delay: 0.2 },
    { left: '92%', top: '62%', fontSize: '2.5rem', opacity: 0.42, duration: 8.5, delay: 2 },
    { left: '12%', top: '72%', fontSize: '1.5rem', opacity: 0.35, duration: 12, delay: 0.7 },
    { left: '28%', top: '82%', fontSize: '2rem', opacity: 0.48, duration: 6.5, delay: 1.8 },
    { left: '70%', top: '78%', fontSize: '1.6rem', opacity: 0.4, duration: 10.5, delay: 0.4 },
    { left: '85%', top: '88%', fontSize: '1.9rem', opacity: 0.36, duration: 8, delay: 1.1 },
    { left: '42%', top: '5%', fontSize: '1.3rem', opacity: 0.3, duration: 11, delay: 2.2 },
    { left: '58%', top: '12%', fontSize: '1.5rem', opacity: 0.32, duration: 9, delay: 0.6 },
    { left: '35%', top: '28%', fontSize: '1.2rem', opacity: 0.28, duration: 13, delay: 1.4 },
    { left: '62%', top: '30%', fontSize: '1.4rem', opacity: 0.3, duration: 10, delay: 0.9 },
    { left: '48%', top: '88%', fontSize: '1.6rem', opacity: 0.35, duration: 8.5, delay: 1.7 },
    { left: '6%', top: '92%', fontSize: '1.8rem', opacity: 0.4, duration: 7, delay: 2.5 },
    { left: '95%', top: '42%', fontSize: '1.3rem', opacity: 0.32, duration: 11.5, delay: 0.1 },
    { left: '52%', top: '72%', fontSize: '1.2rem', opacity: 0.28, duration: 12.5, delay: 1.3 },
]
